import { Book } from '@fable/types'
import { AxiosResponse } from 'axios'
import { BookCarousel } from 'components/carousels'
import { UseQueryResult } from 'react-query'

interface Props {
  query: UseQueryResult<AxiosResponse>
}

export const BookDetailSimilarBooks = ({ query }: Props) => {
  const books = query.data?.data?.response?.books as Book[]

  if (!books?.length) return null

  return (
    <BookCarousel
      title="Similar Books"
      books={books}
      loading={query.isLoading}
      bookLinkRel="nofollow"
      titleSizing="XS"
    />
  )
}
